export const MAX_DOWNLOAD_SIZE = 50000;
